import { FC, useEffect, useState } from 'react';
import {
  Button,
  Container,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import useAuth from 'src/hooks/useAuth';
import * as config from 'src/config';

export interface SuccessDialogProps {
  icsEntry: string;
}

const SuccessDialog: FC<SuccessDialogProps> = (props) => {
  const { icsEntry } = props;
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();
  const isMountedRef = useIsMountedRef();
  const auth = useAuth();

  const handleDownloadClick = () => {
    navigate('/');
  };

  useEffect(() => {
    if (icsEntry === '') { navigate('/'); }
  }, [isMountedRef]);

  if (!icsEntry) {
    return null;
  }

  return (
    <>
      {isVisible && (
      <Container
        maxWidth="sm"
        sx={{ position: 'absolute',
          textAlign: 'center',
          left: 0,
          right: 0,
          marginLeft: 'auto',
          marginRight: 'auto',
          top: '90px',
          background: 'rgba(128, 165, 27, 0.75)',
          backdropFilter: 'blur(9px)',
          borderRadius: '10px' }}
      >
        <Typography sx={{ fontFamily: 'Poppins', fontSize: 18, fontWeight: 700, mt: 3, color: '#1B1D21' }}>Dein Termin ist fixiert!</Typography>
        <Typography sx={{ fontFamily: 'Roboto', fontSize: 13, fontWeight: 700, color: '#FFFFFF' }}>In Kürze bekommst du eine Buchungsbestätigung per Mail</Typography>
        {!auth.isAuthenticated && (
        <>
          <Typography sx={{ fontFamily: 'Poppins', fontSize: 18, fontWeight: 700, mt: 1, color: '#FFFFFF' }}>Wenn der Buchungsprozess noch einfacher sein soll, registriere dich doch einfach bei Kumao</Typography>
          <Button
            color="primary"
            size="large"
            sx={{ borderRadius: '20px', borderWidth: '2px', fontFamily: 'Roboto', backgroundColor: '#FFFFFF', mt: 2, mb: 2, '&:hover': { backgroundColor: '#FFF' } }}
            variant="outlined"
            onClick={handleDownloadClick}
          >
            Beim nächsten Mal, versprochen
          </Button>
        </>
        )}
        {auth.isAuthenticated && (
        <>
          <Button
            color="primary"
            size="large"
            sx={{ borderRadius: '20px', borderWidth: '2px', fontFamily: 'Roboto', backgroundColor: '#FFFFFF', mt: 2, mb: 2, '&:hover': { backgroundColor: '#FFF' } }}
            variant="outlined"
            href={`${config.serverConfig.baseAPIUrl}/api/calendar/mycalendarentry/download/${icsEntry}`}
          >
            Termin herunterladen
          </Button>
          <Button
            color="primary"
            size="large"
            sx={{ borderRadius: '20px', borderWidth: '2px', fontFamily: 'Roboto', backgroundColor: '#FFFFFF', mt: 2, mb: 2, ml: 2, '&:hover': { backgroundColor: '#FFF' } }}
            variant="outlined"
            onClick={() => setIsVisible(false)}
          >
            Schließen
          </Button>
        </>
        )}
      </Container>
      )}
    </>
  );
};

export default SuccessDialog;
